import { hasPermission } from '../utils/permissions.js';

(function () {
    var el = document.getElementById('view-agents');
    if (el && el.dataset.publicC2Host) {
        window.__PUBLIC_C2_HOST__ = el.dataset.publicC2Host;
    }
})();

let allAgents = [];
let currentFilter = 'vps';

/** @type {'host' | 'type' | 'customer' | 'package' | 'expires' | 'status'} */
let fleetSortColumn = 'host';
let fleetSortDir = 'asc';

function fleetExpiryMillis(agent) {
    if (!agent.license_expiry) {
        return fleetSortDir === 'asc' ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    }
    const t = new Date(agent.license_expiry).getTime();
    return Number.isNaN(t)
        ? (fleetSortDir === 'asc' ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY)
        : t;
}

function fleetSortComparableString(agent, col) {
    switch (col) {
        case 'host':
            // Primary: hostname A–Z; secondary: IP for stable ties
            return (agent.hostname || '').toLowerCase() + '\u0001' + (agent.ip_address || '').toLowerCase();
        case 'type':
            return (agent.server_type || 'vps').toLowerCase();
        case 'customer':
            return (agent.client_name || 'Unassigned').toLowerCase();
        case 'package':
            return (agent.package || 'trial').toLowerCase();
        case 'status':
            return (agent.status || '').toLowerCase();
        default:
            return '';
    }
}

function fleetSortCompare(a, b) {
    const mult = fleetSortDir === 'asc' ? 1 : -1;
    if (fleetSortColumn === 'expires') {
        const va = fleetExpiryMillis(a);
        const vb = fleetExpiryMillis(b);
        if (va !== vb) return mult * (va < vb ? -1 : 1);
    } else {
        const sa = fleetSortComparableString(a, fleetSortColumn);
        const sb = fleetSortComparableString(b, fleetSortColumn);
        const c = sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' });
        if (c !== 0) return mult * c;
    }
    return String(a.id || '').localeCompare(String(b.id || ''), undefined, { numeric: true });
}

function updateFleetSortHeaderIcons() {
    const cols = ['host', 'type', 'customer', 'package', 'expires', 'status'];
    cols.forEach((col) => {
        const icon = document.getElementById('fleet-sort-icon-' + col);
        if (!icon) return;
        const active = fleetSortColumn === col;
        icon.className =
            'fas ml-0.5 text-[9px] ' +
            (active
                ? fleetSortDir === 'asc'
                    ? 'fa-sort-up text-neonCyan'
                    : 'fa-sort-down text-neonCyan'
                : 'fa-sort text-slate-600 opacity-50');
    });
}

function sortFleetColumn(col) {
    if (fleetSortColumn === col) {
        fleetSortDir = fleetSortDir === 'asc' ? 'desc' : 'asc';
    } else {
        fleetSortColumn = col;
        fleetSortDir = 'asc';
    }
    renderAgents();
}

// Package duration configs (in days)
const PACKAGE_DURATIONS = {
    trial: { days: 7, name: 'Trial' },
    free: { monthly: 30, yearly: 365, name: 'Free' },
    pro: { monthly: 30, yearly: 365, name: 'Pro' }
};

// Generate license key
function generateLicenseKey() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let key = '';
    for (let i = 0; i < 4; i++) {
        if (i > 0) key += '-';
        for (let j = 0; j < 4; j++) {
            key += chars.charAt(Math.floor(Math.random() * chars.length));
        }
    }
    return key;
}

// Calculate expiry date
function calculateExpiry(pkg, billing) {
    const now = new Date();
    let days = 0;

    if (pkg === 'trial') {
        days = PACKAGE_DURATIONS.trial.days;
    } else {
        days = billing === 'yearly' ? PACKAGE_DURATIONS[pkg].yearly : PACKAGE_DURATIONS[pkg].monthly;
    }

    now.setDate(now.getDate() + days);
    return now;
}

// Update expiry preview
function updateExpiryPreview() {
    const pkg = document.getElementById('server-package').value;
    const billing = document.getElementById('server-billing-cycle').value;
    const expiry = calculateExpiry(pkg, billing);
    document.getElementById('expiry-preview').textContent = 'Expires: ' + expiry.toLocaleDateString();
}

function onPackageChange() {
    const pkg = document.getElementById('server-package').value;
    const billingContainer = document.getElementById('billing-cycle-container');

    if (pkg === 'trial') {
        billingContainer.style.display = 'none';
    } else {
        billingContainer.style.display = 'block';
    }
    updateExpiryPreview();
}

function onRenewPackageChange() {
    const pkg = document.getElementById('renew-package').value;
    const billingContainer = document.getElementById('renew-billing-container');

    if (pkg === 'trial') {
        billingContainer.style.display = 'none';
    } else {
        billingContainer.style.display = 'block';
    }

    const billing = document.getElementById('renew-billing-cycle').value;
    const expiry = calculateExpiry(pkg, billing);
    document.getElementById('renew-expiry-preview').textContent = expiry.toLocaleDateString();
}

// Tab switching
function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

async function parseFetchJson(response) {
    const text = await response.text();
    const trimmed = (text || '').trim();
    if (!trimmed) return null;
    try {
        return JSON.parse(trimmed);
    } catch (e) {
        return null;
    }
}

function filterAgents(type) {
    currentFilter = type;
    ['vps', 'dedicated', 'all'].forEach(t => {
        const btn = document.getElementById('tab-' + t);
        if (t === type) {
            btn.classList.add('text-white', 'bg-slate-800');
            btn.classList.remove('text-slate-500');
        } else {
            btn.classList.remove('text-white', 'bg-slate-800');
            btn.classList.add('text-slate-500');
        }
    });
    renderAgents();
}

function renderAgents() {
    const list = document.getElementById('fleet-list');
    let filtered = allAgents;

    if (currentFilter !== 'all') {
        filtered = allAgents.filter(a => (a.server_type || 'vps').toLowerCase() === currentFilter);
    }

    if (filtered.length === 0) {
        list.innerHTML = '<tr><td colspan="8" class="px-4 py-8 text-center text-slate-500 italic">No servers found in this category.</td></tr>';
        updateFleetSortHeaderIcons();
        return;
    }

    filtered = [...filtered].sort(fleetSortCompare);

    list.innerHTML = filtered.map(agent => {
        const statusColor = agent.status === 'online' ? 'text-green-400' :
            agent.status === 'warning' ? 'text-yellow-400' : 'text-red-400';
        const statusBg = agent.status === 'online' ? 'bg-green-400' :
            agent.status === 'warning' ? 'bg-yellow-400' : 'bg-red-400';
        const typeLabel = (agent.server_type || 'vps').toUpperCase();
        const typeClass = typeLabel === 'DEDICATED' ? 'bg-purple-900 text-purple-300' : 'bg-blue-900 text-blue-300';

        const pkgLabel = (agent.package || 'trial').toUpperCase();
        const pkgClass = pkgLabel === 'PRO' ? 'bg-neonCyan/20 text-neonCyan' :
            pkgLabel === 'FREE' ? 'bg-green-900/50 text-green-400' : 'bg-amber-900/50 text-amber-400';

        const expiry = agent.license_expiry ? new Date(agent.license_expiry) : null;
        const expiryStr = expiry ? expiry.toLocaleDateString() : '--';
        const isExpired = expiry && expiry < new Date();
        const expiryClass = isExpired ? 'text-red-400' : 'text-slate-400';

        const licenseKey = agent.license_key || 'N/A';
        const idJs = JSON.stringify(agent.id);
        const lkAttr = encodeURIComponent(String(licenseKey));
        const canManage = hasPermission('manage:agents');
        const editBtn = canManage
            ? `<button type="button" onclick='event.stopPropagation(); openEditServerModal(${idJs})'
                            class="text-blue-400 hover:text-white px-2 py-1 text-xs border border-blue-900 rounded hover:bg-blue-900/30" title="Edit Server">
                            <i class="fas fa-edit"></i>
                        </button>`
            : '';
        const deleteBtn = canManage
            ? `<button type="button" onclick='event.stopPropagation(); deleteManagedAgent(${idJs})'
                            class="text-red-400 hover:text-white px-2 py-1 text-xs border border-red-900 rounded hover:bg-red-900/30" title="Delete Server">
                            <i class="fas fa-trash"></i>
                        </button>`
            : '';

        return `
            <tr class="hover:bg-slate-800/30 transition-all">
                <td class="px-4 py-4">
                    <div class="font-bold text-white cursor-pointer hover:text-neonCyan" onclick='viewAgent(${idJs})'>${escapeHtml(agent.hostname || 'Unknown')}</div>
                    <div class="text-xs text-slate-500 font-mono">${escapeHtml(agent.ip_address || '--')}</div>
                </td>
                <td class="px-4 py-4">
                    <div class="flex items-center gap-2">
                        <code class="text-xs text-neonCyan bg-slate-800 px-2 py-1 rounded font-mono">${escapeHtml(licenseKey)}</code>
                        <button type="button" data-lk="${lkAttr}" onclick="event.stopPropagation(); copyLicenseKey(decodeURIComponent(this.dataset.lk))" class="text-slate-500 hover:text-white text-xs" title="Copy">
                            <i class="fas fa-copy"></i>
                        </button>
                    </div>
                </td>
                <td class="px-4 py-4">
                    <span class="px-2 py-1 rounded text-[10px] font-bold ${typeClass} border border-white/10">${typeLabel}</span>
                </td>
                <td class="px-4 py-4 text-slate-400 text-xs">${escapeHtml(agent.client_name || 'Unassigned')}</td>
                <td class="px-4 py-4">
                    <span class="px-2 py-1 rounded text-[10px] font-bold ${pkgClass}">${pkgLabel}</span>
                </td>
                <td class="px-4 py-4 text-xs ${expiryClass}">${isExpired ? '⚠ ' : ''}${escapeHtml(expiryStr)}</td>
                <td class="px-4 py-4">
                    <div class="flex items-center gap-2">
                        <span class="w-2 h-2 rounded-full ${statusBg}"></span>
                        <span class="${statusColor} text-xs uppercase font-bold">${escapeHtml(agent.status || '')}</span>
                    </div>
                </td>
                <td class="px-4 py-4 text-center">
                    <div class="flex justify-center gap-1">
                        <button type="button" onclick='showInstallCommand(${idJs})'
                            class="text-green-400 hover:text-white px-2 py-1 text-xs border border-green-900 rounded hover:bg-green-900/30" title="Install Command">
                            <i class="fas fa-terminal"></i>
                        </button>
                        <button type="button" onclick='triggerScan(${idJs})'
                            class="text-neonCyan hover:text-white px-2 py-1 text-xs border border-neonCyan/30 rounded hover:bg-neonCyan/10" title="Scan">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" onclick='openRenewModal(${idJs})'
                            class="text-amber-400 hover:text-white px-2 py-1 text-xs border border-amber-900 rounded hover:bg-amber-900/30" title="Renew">
                            <i class="fas fa-sync"></i>
                        </button>
                        <button type="button" onclick='viewAgent(${idJs})'
                            class="text-slate-400 hover:text-white px-2 py-1 text-xs border border-slate-700 rounded hover:bg-slate-700" title="View Details">
                            <i class="fas fa-eye"></i>
                        </button>
                        ${editBtn}
                        ${deleteBtn}
                    </div>
                </td>
            </tr>
        `;
    }).join('');
    updateFleetSortHeaderIcons();
}

// After renderAgents exists: sync cache from modules/agents.js (router loadAgents → one API fetch, tab filter applied here)
window.syncAgentsPageCache = function (agents) {
    allAgents = Array.isArray(agents) ? agents : [];
    renderAgents();
};

// Modal functions
async function openAddServerModal() {
    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/clients', {
            headers: { 'Authorization': 'Bearer ' + token }
        });
        const text = await response.text();
        if (!response.ok) throw new Error('HTTP ' + response.status);
        let clients;
        try {
            clients = text.trim() ? JSON.parse(text) : [];
        } catch (e) {
            throw new Error('Invalid JSON from /api/clients');
        }
        if (!Array.isArray(clients)) clients = [];

        const select = document.getElementById('server-client');
        select.innerHTML = '<option value="">-- Select Customer --</option>' +
            clients.map(c => `<option value="${escapeHtml(c.id)}">${escapeHtml(c.name)} (${escapeHtml(c.company || 'No Company')})</option>`).join('');
    } catch (e) {
        console.error('Failed to load clients:', e);
    }

    onPackageChange(); // Initialize billing cycle visibility
    updateExpiryPreview();
    document.getElementById('addServerModal').classList.remove('hidden');
}

function closeAddServerModal() {
    document.getElementById('addServerModal').classList.add('hidden');
    document.getElementById('addServerForm').reset();
}

async function submitAddServer(event) {
    event.preventDefault();

    const pkg = document.getElementById('server-package').value;
    const billing = document.getElementById('server-billing-cycle').value;
    const expiry = calculateExpiry(pkg, billing);
    const licenseKey = generateLicenseKey();

    const data = {
        hostname: document.getElementById('server-hostname').value,
        ip_address: document.getElementById('server-ip').value,
        server_type: document.getElementById('server-type').value,
        client_id: parseInt(document.getElementById('server-client').value) || 0,
        os: document.getElementById('server-os').value,
        package: pkg,
        billing_cycle: billing,
        license_key: licenseKey,
        license_expiry: expiry.toISOString(),
        status: 'offline'
    };

    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/agents', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            const result = await parseFetchJson(response);
            alert('Server added successfully!\nLicense Key: ' + licenseKey);
            closeAddServerModal();
            refreshAgentsList();

            if (result && result.id != null) {
                showInstallCommand(result.id);
            }
        } else {
            const err = await parseFetchJson(response);
            alert('Failed to add server: ' + ((err && err.error) || 'Unknown error'));
        }
    } catch (e) {
        console.error('Error adding server:', e);
        alert('Error adding server');
    }
}

function showInstallCommand(agentId) {
    const agent = allAgents.find(a => String(a.id) === String(agentId));
    if (!agent) return;

    document.getElementById('install-server-name').textContent = agent.hostname + ' (' + agent.ip_address + ')';
    document.getElementById('install-license-key').textContent = agent.license_key || 'N/A';

    function normalizeC2Host(h) {
        if (typeof h !== 'string') return '';
        var s = h.trim();
        while (s.length >= 2 && ((s[0] === '"' && s[s.length - 1] === '"') || (s[0] === "'" && s[s.length - 1] === "'"))) {
            s = s.slice(1, -1).trim();
        }
        return s;
    }
    var rawHost = (typeof window.__PUBLIC_C2_HOST__ === 'string' && window.__PUBLIC_C2_HOST__.length)
        ? window.__PUBLIC_C2_HOST__
        : window.location.hostname;
    const c2Host = normalizeC2Host(rawHost) || window.location.hostname;
    const installUrl = window.location.protocol + '//' + c2Host + '/install.sh';
    const lk = JSON.stringify(agent.license_key || 'YOUR-LICENSE-KEY');
    const hn = JSON.stringify(agent.hostname || '');

    const installCmd = `# Method 1: One-liner (C2 URL & gRPC preset dari host yang sama)
curl -fsSL ${JSON.stringify(installUrl)} | bash -s -- \\
--license-key=${lk} \\
--server-ip=${JSON.stringify(c2Host)} \\
--hostname=${hn}

# Method 2: Download and run manually
wget ${JSON.stringify(installUrl)} -O install.sh
chmod +x install.sh
./install.sh \\
--license-key=${lk} \\
--server-ip=${JSON.stringify(c2Host)} \\
--hostname=${hn} \\
--scan-paths="/var/www,/home"`;

    document.getElementById('install-command').textContent = installCmd;
    document.getElementById('installModal').classList.remove('hidden');
}

function closeInstallModal() {
    document.getElementById('installModal').classList.add('hidden');
}

function copyInstallCommand() {
    const cmd = document.getElementById('install-command').textContent;
    navigator.clipboard.writeText(cmd);
    alert('Command copied to clipboard!');
}

function openRenewModal(agentId) {
    const agent = allAgents.find(a => String(a.id) === String(agentId));
    if (!agent) return;

    document.getElementById('renew-agent-id').value = agentId;
    document.getElementById('renew-server-info').textContent = agent.hostname + ' (' + agent.ip_address + ')';
    document.getElementById('renew-package').value = agent.package || 'trial';
    document.getElementById('renew-billing-cycle').value = agent.billing_cycle || 'monthly';

    onRenewPackageChange();
    document.getElementById('renewModal').classList.remove('hidden');
}

function closeRenewModal() {
    document.getElementById('renewModal').classList.add('hidden');
}

async function openEditServerModal(agentId) {
    const agent = allAgents.find(a => String(a.id) === String(agentId));
    if (!agent) return;

    document.getElementById('edit-agent-id').value = agentId;
    document.getElementById('edit-server-hostname').value = agent.hostname || '';
    document.getElementById('edit-server-ip').value = agent.ip_address || '';
    document.getElementById('edit-server-type').value = (agent.server_type || 'vps').toLowerCase();

    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/clients', {
            headers: { 'Authorization': 'Bearer ' + token }
        });
        const text = await response.text();
        if (!response.ok) throw new Error('HTTP ' + response.status);
        let clients;
        try {
            clients = text.trim() ? JSON.parse(text) : [];
        } catch (e) {
            throw new Error('Invalid JSON from /api/clients');
        }
        if (!Array.isArray(clients)) clients = [];

        const select = document.getElementById('edit-server-client');
        const currentClientId = agent.client_id != null ? String(agent.client_id) : '';
        select.innerHTML = '<option value="">-- Select Customer --</option>' +
            clients.map(c => {
                const id = String(c.id);
                const selected = id === currentClientId ? ' selected' : '';
                return `<option value="${escapeHtml(id)}"${selected}>${escapeHtml(c.name)} (${escapeHtml(c.company || 'No Company')})</option>`;
            }).join('');
    } catch (e) {
        console.error('Failed to load clients:', e);
    }

    document.getElementById('editServerModal').classList.remove('hidden');
}

function closeEditServerModal() {
    document.getElementById('editServerModal').classList.add('hidden');
    document.getElementById('editServerForm').reset();
}

async function submitEditServer(event) {
    event.preventDefault();

    const agentId = document.getElementById('edit-agent-id').value;
    const data = {
        hostname: document.getElementById('edit-server-hostname').value.trim(),
        ip_address: document.getElementById('edit-server-ip').value.trim(),
        server_type: document.getElementById('edit-server-type').value,
        client_id: parseInt(document.getElementById('edit-server-client').value, 10) || 0
    };

    if (!data.hostname || !data.ip_address) {
        alert('Hostname and IP address are required');
        return;
    }

    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/agents/' + encodeURIComponent(agentId), {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        if (response.ok) {
            alert('Server updated successfully!');
            closeEditServerModal();
            refreshAgentsList();
        } else {
            const err = await parseFetchJson(response);
            alert('Failed to update server: ' + ((err && err.error) || 'Unknown error'));
        }
    } catch (e) {
        console.error('Error updating server:', e);
        alert('Error updating server');
    }
}

async function submitRenew() {
    const agentId = document.getElementById('renew-agent-id').value;
    const pkg = document.getElementById('renew-package').value;
    const billing = document.getElementById('renew-billing-cycle').value;
    const expiry = calculateExpiry(pkg, billing);

    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/agents/' + agentId, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                package: pkg,
                billing_cycle: billing,
                license_expiry: expiry.toISOString()
            })
        });

        if (response.ok) {
            alert('License renewed successfully!');
            closeRenewModal();
            refreshAgentsList();
        } else {
            alert('Failed to renew license');
        }
    } catch (e) {
        console.error(e);
        alert('Error renewing license');
    }
}

function copyLicenseKey(key) {
    if (key === 'N/A') {
        alert('No license key available');
        return;
    }
    navigator.clipboard.writeText(key);
    alert('License key copied: ' + key);
}

// viewAgent + triggerScan: didefinisikan di modules/agents.js (window.*) — jangan duplikat di sini

async function loadAgentsData() {
    try {
        const tokenCookie = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
        const token = tokenCookie ? tokenCookie.split('=')[1] : '';
        const response = await fetch('/api/agents', {
            headers: { 'Authorization': 'Bearer ' + token }
        });
        const text = await response.text();
        if (!response.ok) {
            throw new Error('HTTP ' + response.status);
        }
        let data;
        try {
            data = text.trim() ? JSON.parse(text) : [];
        } catch (e) {
            throw new Error('Invalid JSON from /api/agents');
        }
        allAgents = Array.isArray(data) ? data : [];
        renderAgents();
    } catch (e) {
        console.error('Failed to load agents:', e);
        document.getElementById('fleet-list').innerHTML =
            '<tr><td colspan="8" class="px-6 py-8 text-center text-red-400">Failed to load servers</td></tr>';
    }
}

/** Prefer shared module loader (api client); fallback if router has not run yet */
async function refreshAgentsList() {
    if (typeof window.loadAgents === 'function') {
        await window.loadAgents();
        return;
    }
    await loadAgentsData();
}

// Initial load: router switchView('agents') calls loadAgents(); no duplicate fetch here

// Expose handlers only on agents page to avoid clobbering
// same-named functions from other views (e.g. customer detail modal).
(function exposeAgentPageHandlers() {
    if (!document.getElementById('view-agents')) {
        return;
    }

    window.filterAgents = filterAgents;
    window.openAddServerModal = openAddServerModal;
    window.closeAddServerModal = closeAddServerModal;
    window.submitAddServer = submitAddServer;
    window.onPackageChange = onPackageChange;
    window.onRenewPackageChange = onRenewPackageChange;
    window.showInstallCommand = showInstallCommand;
    window.closeInstallModal = closeInstallModal;
    window.copyInstallCommand = copyInstallCommand;
    window.openRenewModal = openRenewModal;
    window.closeRenewModal = closeRenewModal;
    window.submitRenew = submitRenew;
    window.openEditServerModal = openEditServerModal;
    window.closeEditServerModal = closeEditServerModal;
    window.submitEditServer = submitEditServer;
    window.copyLicenseKey = copyLicenseKey;
})();

/** Used by modules/agents.js when syncAgentsPageCache is unavailable; mirrors table sort state. */
window.__applyFleetTableSort = function (agents) {
    const arr = Array.isArray(agents) ? agents.slice() : [];
    arr.sort(fleetSortCompare);
    return arr;
};

// Expose sort helpers on window so inline handlers / delegated clicks always resolve (module load order vs DOM).
window.sortFleetColumn = sortFleetColumn;
window.updateFleetSortHeaderIcons = updateFleetSortHeaderIcons;

document.addEventListener('click', function fleetTableSortDelegated(e) {
    const th = e.target.closest('th[data-fleet-sort]');
    if (!th) return;
    const root = document.getElementById('view-agents');
    if (!root || !root.contains(th)) return;
    const col = th.getAttribute('data-fleet-sort');
    if (!col) return;
    sortFleetColumn(col);
});

export {};
